import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import cls from '@utils/css-select'
import styles from './styles.scss';
import AcBtn from 'ac-components/ac-btn';
import Container from '../container/main'
import Title from '../title/main'
import {
	changeAvatar,
	changeBaseInfo,
	changePwd,
	BaseInfoEditFormProps,
} from './edit-form';
import { ConnectState } from 'states/connect';
import { getAgeOrBirth } from 'pages/offical/personal/const';
import { OperationalModal } from 'ac-components/modal';
import { EmailEditForm, AddrEditForm } from './edit-form'
import { sendEvent } from '@core/track';
import { useUser } from 'hooks/use-user';
import { useTranslation } from 'hooks/use-translation';
import AcIcon from 'ac-components/ac-icon';
const cx = cls(styles)

type EditType = 'base' | 'email' | 'addr' | 'pwd' | 'avatar' | ''
const avatarDefault = 'https://web-data.zmlearn.com/image/qhnwXiVv7CcoLqmCnm2BsR/avatar_default_large.png'
const _eveId: { [key: string]: string } = {
	email: 'EAF_1d1e4c019539bc4d',
	addr: 'EAF_cd5bbd3ed2a19b21'
}

interface Validate {
	(cb?: () => void): void;
}
export interface EditFormRef {
	validate: Validate;
}


function EditIcon(props: { type: EditType; onClick: (type: EditType) => void }) {
	const handleEditClick = () => {
		props.onClick && props.onClick(props.type)
	}
	return (
		<AcIcon
			icon="icon_edit"
			size={24}
			className={styles['edit-icon']}
			onClick={handleEditClick} />
	)
}

function ProfileInfo() {
	const { avatar, userName, birthday, areaCode, mobile, email, addressInfo } = useUser()
	const trans = useTranslation('profile');
	const { transData, t } = trans
	const { info, email: emailName, password, address, phone, changePs, transRecord, noTransYet, logout, age } = transData
	const [operationModalShow, setOperationModalShow] = useState<boolean>(false)
	const [editType, setEditType] = useState<EditType>('')
	const emailRef = useRef<EditFormRef | null>(null)
	const addrRef = useRef<EditFormRef | null>(null)
	const [modalTitle, setModalTitle] = useState('')
	function handleModalClose() {
		setEditType('')
		setOperationModalShow(false)
	}

	const handleEditClick = (type: EditType) => {
		if (type === 'pwd') {
			//transData,t是由hooks/use-translation获取的,changePwd不是一个组件没法使用hook,所以使用props传入
			changePwd(trans)
			return
		}
		setEditType(type)
		sendEvent({
			eventId: _eveId[type]
		})
		setOperationModalShow(true)
	}

	function handleModalCancelClick() {
		handleModalClose()
	}

	function handleModalOkClick() {
		let _temp
		if (editType === 'email') {
			_temp = emailRef.current?.validate(handleModalClose)
		} else if (editType === 'addr') {
			_temp = addrRef.current?.validate(handleModalClose)
		}
	}

	useEffect(() => {
		switch (editType) {
			case 'email':
				setModalTitle('Edit Email')
				break
			default:
				setModalTitle('')
		}
	}, [editType])

	return (
		<Container className={cx('info-wrap')}>
			<OperationalModal
				okText={editType === 'email' ? 'Save' : 'OK'}
				title={modalTitle}
				show={operationModalShow}
				onOk={handleModalOkClick}
				onCancel={handleModalCancelClick}
				onClose={handleModalClose}>
				{editType === 'email' && <EmailEditForm email={email || ''} ref={emailRef} />}
				{editType === 'addr' && <AddrEditForm addressInfo={addressInfo || null} ref={addrRef} />}
			</OperationalModal>
			{/* <Title>Profile Information</Title> */}
			<div className={cx('info-detail')}>
				<div className={cx('simple-info')}>
					<div className={cx('head-pic')}>
						<div className={cx('pic-wrap')}>
							<img src={avatar || avatarDefault} alt='avatar' loading='lazy' />
						</div>
						{/*<span className={cx('upload-head-pic_btn')} onClick={() => handleEditClick('avatar')}>*/}
						{/*	<i className={cx('iconfont', 'icon_upload')} />*/}
						{/*</span>*/}
					</div>
					<div className={cx('info')}>
						<p className={cx('name')}>
							<span>{userName}</span>
							{/*<EditIcon type='base' onClick={handleEditClick}/>*/}
						</p>
						<div className={cx('age-wrap')}>
							<span className={cx('age')}>{`${age} ${getAgeOrBirth(undefined, birthday)}`}</span>
						</div>
					</div>
				</div>
				<div className={cx('info-table')}>
					<ul className={cx('table-block')}>
						<li className={cx('table-row')}>
							<div className={cx('table-cell')}>
								<p className={cx('label')}>{emailName}</p>
							</div>
							<div className={cx('table-cell')}>
								<p className={cx('value-wrap')}>
									<span className={cx('value', { 'empty': !email })}>{email || '-'}</span>
									<EditIcon type='email' onClick={handleEditClick} />
								</p>
							</div>
						</li>
						<li className={cx('table-row')}>
							<div className={cx('table-cell')}>
								<p className={cx('label')}>{phone}</p>
							</div>
							<div className={cx('table-cell')}>
								<p className={cx('value-wrap')}>
									<span className={cx('value', { 'empty': !(areaCode && mobile) })}>
										{ areaCode && mobile ? `${areaCode ? '+' + (areaCode) : ''} ${mobile}` : '-' }
									</span>
								</p>
							</div>
						</li>
						<li className={cx('table-row')}>
							<div className={cx('table-cell')}>
								<p className={cx('label')}>{address}</p>
							</div>
							<div className={cx('table-cell')}>
								<p className={cx('value-wrap')}>
									<span className={cx('value', { empty: !addressInfo.address })}>{addressInfo?.address || '-'}</span>
									<EditIcon type='addr' onClick={handleEditClick} />
								</p>
							</div>
						</li>
						<li className={cx('table-row')}>
							<div className={cx('table-cell')}>
								<p className={cx('label')}>{password}</p>
							</div>
							<div className={cx('table-cell')}>
								<div className={cx('value-wrap', 'value_pwd-change')}>
									<AcBtn type='txt' onClick={() => {
										handleEditClick('pwd')
									}}>{changePs}</AcBtn>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</Container>
	)
}

export default ProfileInfo
